// Generated by ReScript, PLEASE EDIT WITH CARE

import * as MomentTzCore from "./MomentTzCore";

var Moment = {};

function setTz(prim) {
  MomentTzCore.setTz(prim);
  
}

function momentNow(prim) {
  return MomentTzCore.now();
}

function momentWithTimestampMS(prim) {
  return MomentTzCore.momentWithTimestampMS(prim);
}

function format(prim0, prim1) {
  return MomentTzCore.format(prim0, prim1);
}

function momentWithDate(prim) {
  return MomentTzCore.momentWithDate(prim);
}

function toJsDate(prim) {
  return MomentTzCore.toJsDate(prim);
}

function momentWithFormat(prim0, prim1) {
  return MomentTzCore.momentWithFormat(prim0, prim1);
}

function isBefore(prim0, prim1) {
  return MomentTzCore.isBefore(prim0, prim1);
}

function isAfter(prim0, prim1) {
  return MomentTzCore.isBefore(prim0, prim1);
}

function getDateTimeAfterElapsedTime(prim0, prim1, prim2) {
  return MomentTzCore.getDateTimeAfterElapsedTime(prim0, prim1, prim2);
}

function getDateTimeBeforeElapsedTime(prim0, prim1, prim2) {
  return MomentTzCore.getDateTimeBeforeElapsedTime(prim0, prim1, prim2);
}

function startOf(prim0, prim1) {
  return MomentTzCore.startOf(prim0, prim1);
}

function endOf(prim0, prim1) {
  return MomentTzCore.endOf(prim0, prim1);
}

function valueOf(prim) {
  return MomentTzCore.valueOf(prim);
}

function getTz(prim) {
  return MomentTzCore.getTz();
}

function day(prim) {
  return MomentTzCore.day(prim);
}

function isValid(prim) {
  return MomentTzCore.isValid(prim);
}

export {
  Moment ,
  setTz ,
  momentNow ,
  momentWithTimestampMS ,
  format ,
  momentWithDate ,
  toJsDate ,
  momentWithFormat ,
  isBefore ,
  isAfter ,
  getDateTimeAfterElapsedTime ,
  getDateTimeBeforeElapsedTime ,
  startOf ,
  endOf ,
  valueOf ,
  getTz ,
  day ,
  isValid ,
  
}
/* ./MomentTzCore Not a pure module */
